var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asideWrapper"},[_c('div',{class:{icon: true, top: true, show: _vm.topShow},on:{"click":_vm.gotoTop}})])}
var staticRenderFns = []

export { render, staticRenderFns }